import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import {
  firstShown,
  PAGE_SIZE,
  reloadUsers,
  selectIsManageUsersLoading,
  selectNumberOfUsersSkipped,
  selectTotalUsersInQuery,
  selectTotalUsersReturned
} from "../ducks/manage-users.duck";
import { tablet } from '@shared/ui/atoms/MediaQueries';

export function ManageUsersPaginationControls(props: Props) {
  const dispatch = useDispatch();
  const totalUsersInQuery = useSelector(selectTotalUsersInQuery);
  const totalUsersReturned = useSelector(selectTotalUsersReturned);
  const skipped = useSelector(selectNumberOfUsersSkipped);
  const isManageUsersLoading = useSelector(selectIsManageUsersLoading);

  // Paging keeps the page's filter, search and sort
  const previous = () => {
    const toSkip = (skipped - PAGE_SIZE < 0 ? 0 : skipped - PAGE_SIZE);
    if (toSkip === skipped) return;
    dispatch(reloadUsers({skip: toSkip}));
  }

  const next = () => {
    const toSkip = skipped + PAGE_SIZE;
    if (toSkip >= totalUsersInQuery) return;
    dispatch(reloadUsers({skip: toSkip}));
  }

  return (
    <Row>
      <OutlineButton icon={IconTypes.Previous}
                     click={previous}
                     disabled={isManageUsersLoading} />
      <div>
        <BodyRegular>Showing {firstShown(skipped, totalUsersReturned)} - {(skipped + totalUsersReturned)} of {totalUsersInQuery}</BodyRegular>
      </div>
      <OutlineButton icon={IconTypes.Next}
                     click={next}
                     disabled={isManageUsersLoading} />
    </Row>
  )
}

interface Props {
}

const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  button {
    margin-bottom: 16px;
    width: 100%;
    max-width: 100%;
  }
  p {
    margin-bottom: 16px;
  }
  @media (${tablet}) {
    flex-direction: row;
    justify-content: space-between;
    button, p {
      margin: 0;
    }
    button {
      max-width: 192px;
    }
  }
`
